import React, { useState } from 'react';
import { Link } from "react-router-dom";
import {
  Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
  Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, Typography, Pagination
} from '@mui/material';
import { ExpandMore, ExpandLess, Search, } from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Navbar from '../Layouts/Navbar';

export default function PreReservationTable() {

  const [open, setOpen] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);

  // New dataset matching the image
  const rows = [
    { id: 1, date: '14/12/2024', trajet: 'Trajet A', direction: 'Entrée', heure: 7, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 2, date: '14/12/2024', trajet: 'Trajet B', direction: 'Entrée', heure: 8, valider: 10, nonvalider: 0, traitement: 0,  },
    { id: 3, date: '14/12/2024', trajet: 'Trajet C', direction: 'Entrée', heure: 9, valider: 4, nonvalider: 0, traitement: 0,  },
    { id: 4, date: '14/12/2024', trajet: 'Trajet D', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 5, date: '15/12/2024', trajet: 'Trajet E', direction: 'Entrée', heure: 7, valider: 1, nonvalider: 0, traitement: 0,  },
    { id: 6, date: '15/12/2024', trajet: 'Trajet F', direction: 'Entrée', heure: 8, valider: 6, nonvalider: 0, traitement: 0,  },
    { id: 7, date: '15/12/2024', trajet: 'Trajet G', direction: 'Entrée', heure: 9, valider: 4, nonvalider: 0, traitement: 0,  },
    { id: 8, date: '15/12/2024', trajet: 'Trajet H', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 4348, date: '15/12/2024', trajet: 'Trajet H', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 443, date: '15/12/2024', trajet: 'Trajet H', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 43, date: '15/12/2024', trajet: 'Trajet H', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 438, date: '15/12/2024', trajet: 'Trajet H', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 82, date: '15/12/2024', trajet: 'Trajet H', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 9, date: '16/12/2024', trajet: 'Trajet I', direction: 'Entrée', heure: 7, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 10, date: '16/12/2024', trajet: 'Trajet J', direction: 'Entrée', heure: 8, valider: 6, nonvalider: 0, traitement: 0, },
    { id: 11, date: '16/12/2024', trajet: 'Trajet K', direction: 'Entrée', heure: 9, valider: 4, nonvalider: 0, traitement: 0, },
    { id: 12, date: '16/12/2024', trajet: 'Trajet L', direction: 'Entrée', heure: 10, valider: 1, nonvalider: 0, traitement: 0, },
    { id: 13, date: '17/12/2024', trajet: 'Trajet M', direction: 'Entrée', heure: 7, valider: 1, nonvalider: 0, traitement: 0,  },
  ];

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1); // reset to first page when rows per page change
  };

  const paginatedRows = rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(rows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <CalendarMonthIcon />
            <Typography variant="h6"> RECAP DES RESERVATIONS </Typography>
          </Box>
        </Box>
        {/* Search Section */}
        <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>
        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
              <TextField
                type="date"
                label="Date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  },
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                },
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Heure</InputLabel>
                <Select label="Heure">
                  <MenuItem value="7">7:00</MenuItem>
                  <MenuItem value="8">8:00</MenuItem>
                  <MenuItem value="9">9:00</MenuItem>
                  <MenuItem value="10">10:00</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                },
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Trajet</InputLabel>
                <Select label="Trajet">
                  <MenuItem value="Trajet A">Trajet A</MenuItem>
                  <MenuItem value="Trajet B">Trajet B</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" gap={2} mb={2}>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                },
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Pickup</InputLabel>
                <Select label="Pickup">
                  <MenuItem value="Toubkal">Toubkal</MenuItem>
                  <MenuItem value="02 AV 4ÈME DMM">02 AV 4ÈME DMM</MenuItem>
                  <MenuItem value="06 NAJD">06 NAJD</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                },
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Direction</InputLabel>
                <Select label="Direction">
                  <MenuItem value="Entrée">Entrée</MenuItem>
                  <MenuItem value="Sortie">Sortie</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Reset</Button>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Search</Button>
            </Box>
          </Paper>
        </Collapse>
        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Trajet</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Direction</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Heure</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Nombre de réservations</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map((row, index) => (
                <TableRow key={row.id} hover>
                  <TableCell>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell>{row.trajet}</TableCell>
                  <TableCell>{row.direction}</TableCell>
                  <TableCell>{row.heure}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Box
                        sx={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '30%',
                          backgroundColor: 'green',
                          color: 'white',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {row.valider}
                      </Box>
                      <Box
                        sx={{
                            width: '24px',
                            height: '24px',
                          borderRadius: '30%',
                          backgroundColor:'red' ,
                          color: 'white',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {row.nonvalider}
                      </Box>
                      <Box
                        sx={{
                            width: '24px',
                            height: '24px',
                          borderRadius: '30%',
                          backgroundColor:'black' ,
                          color: 'white',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {row.traitement}
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Link to={`/`} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          '&:hover': { textDecoration: 'underline' },
                        }}
                      >
                        Détails de la navette
                      </Box>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Pagination + entries info */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              },
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}